import { useQuery } from '@tanstack/react-query';
import { meetingTypeApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useMeetingTypes(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.jobs.meetingTypes(jobId ?? -1),
    queryFn: ({ signal }) =>
      meetingTypeApiClient.listMeetingTypes(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 60_000,
    meta: { errorContext: 'meeting types' },
  });
}
